var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_13759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 11.1428L10.6819 14.8791C11.5258 15.2307 12.4753 15.2307 13.3192 14.8791L22.2863 11.1428",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.572 6H3.42913C2.48236 6 1.71484 6.76752 1.71484 7.71429V20.5714C1.71484 21.5182 2.48236 22.2857 3.42913 22.2857H20.572C21.5188 22.2857 22.2863 21.5182 22.2863 20.5714V7.71429C22.2863 6.76752 21.5188 6 20.572 6Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2863 6.00007V3.42864C16.2863 2.97398 16.1057 2.53795 15.7842 2.21645C15.4627 1.89497 15.0266 1.71436 14.572 1.71436H9.42913C8.97447 1.71436 8.53844 1.89497 8.21694 2.21645C7.89546 2.53795 7.71484 2.97398 7.71484 3.42864V6.00007",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_13759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessHub);
export default __webpack_public_path__ + "static/media/business_hub.1b450439f2502e59c32043bd8bc8452d.svg";
export { ForwardRef as ReactComponent };